import { PalletBox } from '../../models/pallet-box';
import { isUUID } from '../../trucks/trucksUtils';

export function palletBoxName(palletBox: PalletBox) {
  const name = `${isUUID(palletBox.externalId) ? '' : palletBox.externalId} ${palletBox.name}`;
  if (palletBox.chuteId) {
    return `${name} (${palletBox.chuteId})`;
  }
  return name;
}
